module.exports = __webpack_public_path__ + "assets/img/about-content-icon3.79fb0514.svg";